import { createSelector } from '@reduxjs/toolkit';

export const get = state => state.graph;

export const loading = createSelector(get, state => state.loading);
export const error = createSelector(get, state => state.error);
export const data = createSelector(get, state => state.assignments);
export const students = createSelector(get, state => state.users);
